export const APPROVE_WITH_CHANGES = 1
export const APPROVE_WITH_NO_CHANGES = 2
export const APPROVE_WITH_CHANGES_TEXT = 'You have made the following changes:'

export const SET_ZONE = 3

export const REJECT_OFFER = 4

export const NO_CHANGES_TEXT = 'There are no changes'
export const SUBMIT_TEXT = 'Are you sure to submit?'
export const REJECT_TEXT = 'Are you sure to submit with the reason?'

export const MERCHANT_ROLE = 'merchant'
export const SUPER_USER_ROLE = 'superuser'
export const EMAIL_SELECTED_BY_SUPERUSER = 'email_selected_by_superuser'
export const MERCHANT_SELECTED_BY_SUPERUSER = 'merchant_selected_by_superuser'
export const CLEAR_FILTER = 'clear_filter'

export const REGULAR_RETAIL = 'regular_retail'
export const SUGGESTED_SB_ALLOWANCE = 'manufacturer_suggested_sb_allowance'
export const SUGGESTED_OI_ALLOWANCE = 'manufacturer_suggested_oi_allowance'
export const SUGGESTED_RETAIL_SAVINGS = 'manufacturer_suggested_retail_savings'
export const SUGGESTED_RETAIL = 'manufacturer_suggested_retail'
export const RETAIL_FUNDING = 'psp_retail_funding'
export const FUNDING_MERCHANT_ADJUSTED = 'psp_funding_merchant_adjusted'

export const VENDOR_ALLOWANCE = 'vendorAllowance'
export const PSP_ALLOWANCE = 'pspAllowance'
export const VENDOR_ALLOWANCE_PERCENT = 'vendorAllowancePercent'
export const RETAIL_SAVING_PERCENT = 'retailSavingsPercent'
export const RETAIL_SAVING = 'retailSavings'
export const RETAIL_PRICE = 'retailPrice'
export const MERCHANT_PORTAL_GUIDE_URL = 'https://storage.googleapis.com/pspvendorportaltest/Merchant%20Portal%20Guide.pdf'



// WEBPACK FOOTER //
// ./src/constants/Constants.js